import React from "react"

import { ModalDelete } from "../Modal/ModalDelete"
import DeleteRepeatModal from "../DeleteRepeatModal"

const DeleteStepsModal = (props) => {
  const { 
    isOpenStepOne,
    language,
    name,
    onCloseModalStepOne,
    onCloseModalStepTwo,
    onSubmitModalStepOne,
    onSubmitModalStepTwo,
    isOpenStepTwo,
    validate,
    selectedKey,
    onSelected,
    colorTheme,
  } = props
  
  return (
    <React.Fragment>
      { isOpenStepOne && (
          <ModalDelete 
            language={language}
            name={name}
            onClickCancel={onCloseModalStepOne}
            onClickAction={onSubmitModalStepOne}
            validate={validate}
            colorTheme={colorTheme}
          />
        )
      }

      <DeleteRepeatModal 
        isVisible={isOpenStepTwo}
        selectedKey={selectedKey}
        language={language}
        onClose={onCloseModalStepTwo}
        onSubmit={onSubmitModalStepTwo}
        onSelected={onSelected}
        colorTheme={colorTheme}
      />
    </React.Fragment>
  )
}

export default DeleteStepsModal
